import React from 'react';
import './css/theme.css';  // Asegúrate de que la ruta sea la correcta
//import './css/smart-cart/minicart-theme.css'

import './css/mbr-additional.css'


const Header = () => {
  return (
  <section data-bs-version="5.1" className="header15 cid-tRE6AH6upE reveal" id="header15-z">
    <div className="container-fluid">
      <div className="row justify-content-center">
        <div className="mbr-figure col-12">
          <iframe
            title="Video de Vimeo"
            className="mbr-embedded-video"
            src="https://player.vimeo.com/video/874547739?autoplay=1&amp;loop=0"
            width="100%"
            height="720"
            frameBorder="0"
            allowFullScreen
          ></iframe>
        </div>
        <div className="col-12">
          <div className="text-wrapper">
            <h2 className="mbr-section-title">
              <strong>
                Personaliza la atención en tu negocio con asistai 
              </strong>
            </h2>
            <p className="mbr-text display-7">
              asistai ofrece Inteligencia Artificial para ayudar a las empresas a mejorar y personalizar la atención a sus clientes. Utilizando asistentes digitales, las empresas pueden ofrecer a sus clientes una experiencia de atención amigable y personalizada.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  );
};

export default Header;
